import * as types from './type'
import * as api from './api'

export default {
  state: {
    userInfo: {
      uid: 0,
      mobile: '',
      nickname: '',
      portrait: '',
      ali_info: {
        ali_account: '',
        ali_realname: ''
      },
      wechat_info: {
        wechat_realname: ''
      }
    },
    getCodeSuccess: false,
    share_url: '',
    qrcode_url: '',
    share_url_wechat: '',
    share_info: {
      title: '',
      content: '',
      icon: ''
    }
  },
  mutations: {
    userObjState (state, obj) {
      if (!state[obj.key]) return
      state[obj.key] = Object.assign(state[obj.key], obj.val)
    },
    userState (state, obj) {
      state[obj.key] = obj.val
    }
  },
  actions: {
    // 获取用户信息
    async [types.URI_GET_USERINFO] ({ commit }) {
      let res = await api.getUserInfo()
      if (res && res.status === 200) {
        commit('userObjState', { key: 'userInfo', val: res.data.payload })
      }
      return res
    },
    // 获取手机验证码
    async [types.URI_GET_PHONECODE] ({ commit }, params) {
      let res = await api.getMoblieCode(params)
      if (res && res.status === 200) {
        commit('userState', { key: 'getCodeSuccess', val: true })
      } else {
        commit('userState', { key: 'getCodeSuccess', val: false })
      }
      return res
    },
    // 绑定/修改手机
    async [types.URI_GET_BINDPHONE] ({ commit }, params) {
      let res = await api.bindMobile(params)
      if (res && res.status === 200) {
        return res
      }
    },
    // 用户登陆-切换账号
    async [types.URI_MOBLIE_LOGIN] ({ commit }, params) {
      let res = await api.userLogin(params)
      if (res && res.status === 200) {
        return res.data
      }
    },
    // 绑定微信
    async [types.URI_WECHAT_BINDING] ({ commit }, params) {
      let res = await api.bindWechat(params)
      if (res && res.status === 200) {
        return res
      }
    },
    // 链接分享
    async [types.URL_LINK_SHARE] ({ commit }, params) {
      let res = await api.shareLink(params)
      if (res && res.status === 200) {
        commit('userState', { key: 'share_url', val: res.data.payload.share_url })
        commit('userState', { key: 'qrcode_url', val: res.data.payload.qrcode_url })
        commit('userState', { key: 'share_url_wechat', val: res.data.payload.share_url_wechat })
        commit('userState', { key: 'share_info', val: res.data.payload.share_info })
      }
      return res
    }
  }
}
